import { css } from 'linaria';

export const headerSectionText = css`
  && {
    @media (--only-mobile) {
      padding: 24px 0;
    }
  }
`;

export const headerSection = css`
  && {
    background-color: #21282B;

    > section:first-of-type {
      @media (--only-largeDesktop) {
        height: 275px;
      }

      @media (--only-desktop) {
        height: 300px;
      }
    }
  }
`;

export const headerSectionCards = css`
  && {
    @media (--only-largeDesktop) {
      padding-top: 38px;
      padding-bottom: 30px;
    }

    @media (--only-desktop) {
      margin-top: 24px;
      margin-bottom: 24px;
    }
  }
`;

export const headerSectionTitle = css`
  && {
    @media (--from-desktop) {
      margin-bottom: 16px;
    }
    @media (--to-desktop) {
      margin-bottom: 0;
    }
  }
`;

export const headerContent = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  
  @media (--to-desktop) {
    flex-direction: column;
    width: 100%;
  }
`;

export const headerImage = css`
  && {
    @media (--only-largeDesktop) {
      width: 575px;
      height: 275px;
      left: 615px;
    }

    @media (--only-desktop) {
      width: 458px;
      height: 300px;
    }

    @media (--only-tablet) {
      height: 308px;
      width: 100%;
    }
  }
`;
